import { RemoteDiagnosticsGetVddListByComChannelGeneric } from '../remote-diagnostics.model';
import { LogicalLinkVddList } from './mockedVddList.model';
export class LL_0005_ADIO_PlusBus02 implements LogicalLinkVddList {
  vddList(): RemoteDiagnosticsGetVddListByComChannelGeneric {
    return {
      service: 'DS_ReadDataByIdent',
      ecu: 'LL_0005_ADIO_PlusBus02',
      type: 'ListOfVDDsByBaseVariant',
      structure: [
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'ErrorDtcList',
          structure: [
            {
              TI_texttableentry: 'TI_BusIdentification',
              isRead: 'true',
              interval: '256',
              texttableentry: 'BusIdentification',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcList',
              isRead: 'true',
              interval: '265',
              texttableentry: 'ErrorDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OutsideTemperatureSensor',
              isRead: 'true',
              interval: '274',
              texttableentry: 'OutsideTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_Date',
              isRead: 'true',
              interval: '505',
              texttableentry: 'Date',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Time',
              isRead: 'true',
              interval: '506',
              texttableentry: 'Time',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetStatistics',
              isRead: 'true',
              interval: '570',
              texttableentry: 'ResetStatistics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemoteReset',
              isRead: 'true',
              interval: '573',
              texttableentry: 'RemoteReset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStatus',
              isRead: 'false',
              interval: '575',
              texttableentry: 'SetDeliveryStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SoftwareVersion',
              isRead: 'true',
              interval: '580',
              texttableentry: 'SoftwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HardwareVersion',
              isRead: 'true',
              interval: '581',
              texttableentry: 'HardwareVersion',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitOperationHours',
              isRead: 'true',
              interval: '590',
              texttableentry: 'ElectronicControlUnitOperationHours',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogDigitalAccessoryOneModulFunction',
              isRead: 'true',
              interval: '645',
              texttableentry: 'GenericAnalogDigitalAccessoryOneModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionActivation',
              isRead: 'true',
              interval: '873',
              texttableentry: 'LegionellaProtectionActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductionTraceabilityByte',
              isRead: 'true',
              interval: '922',
              texttableentry: 'ProductionTraceabilityByte',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicTraceabilityNumber',
              isRead: 'true',
              interval: '928',
              texttableentry: 'ElectronicTraceabilityNumber',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarCircuitWaterFlowRate',
              isRead: 'true',
              interval: '950',
              texttableentry: 'SolarCircuitWaterFlowRate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarCircuitExtendedFunctions',
              isRead: 'true',
              interval: '951',
              texttableentry: 'SolarCircuitExtendedFunctions',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarEnergyYield',
              isRead: 'true',
              interval: '953',
              texttableentry: 'SolarEnergyYield',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BootLoaderVersion',
              isRead: 'true',
              interval: '962',
              texttableentry: 'BootLoaderVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '987',
              texttableentry: 'MixerOneCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1118',
              texttableentry: 'SolarCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarMaximumLoadingTemperature',
              isRead: 'true',
              interval: '1125',
              texttableentry: 'SolarMaximumLoadingTemperature',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarMinimumMaximumCollectorTemperature',
              isRead: 'true',
              interval: '1126',
              texttableentry: 'SolarMinimumMaximumCollectorTemperature',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarCollectorFrostprotection',
              isRead: 'true',
              interval: '1127',
              texttableentry: 'SolarCollectorFrostprotection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarStagnationHours',
              isRead: 'true',
              interval: '1128',
              texttableentry: 'SolarStagnationHours',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarAlternatelyCharge',
              isRead: 'true',
              interval: '1129',
              texttableentry: 'SolarAlternatelyCharge',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarProperty',
              isRead: 'true',
              interval: '1136',
              texttableentry: 'SolarProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarCircuitPumpStatistical',
              isRead: 'true',
              interval: '1172',
              texttableentry: 'SolarCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1192',
              texttableentry: 'MixerOneCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ActorSensorTest',
              isRead: 'true',
              interval: '1239',
              texttableentry: 'ActorSensorTest',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarChargingDomesticHotWaterSetpoint',
              isRead: 'true',
              interval: '1394',
              texttableentry: 'SolarChargingDomesticHotWaterSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ApplicationChecksum',
              isRead: 'true',
              interval: '1451',
              texttableentry: 'ApplicationChecksum',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputOneValue',
              isRead: 'true',
              interval: '1456',
              texttableentry: 'DeviceDigitalOutputOneValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputTwoValue',
              isRead: 'true',
              interval: '1457',
              texttableentry: 'DeviceDigitalOutputTwoValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputThreeValue',
              isRead: 'true',
              interval: '1458',
              texttableentry: 'DeviceDigitalOutputThreeValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DevicePwmOutputOneValue',
              isRead: 'true',
              interval: '1462',
              texttableentry: 'DevicePwmOutputOneValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AnalogAdcInputValues',
              isRead: 'true',
              interval: '1466',
              texttableentry: 'AnalogAdcInputValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarCircuitPumpHysteresis',
              isRead: 'true',
              interval: '1492',
              texttableentry: 'SolarCircuitPumpHysteresis',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputOneValue',
              isRead: 'true',
              interval: '1497',
              texttableentry: 'DeviceAnalogInputOneValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputTwoValue',
              isRead: 'true',
              interval: '1498',
              texttableentry: 'DeviceAnalogInputTwoValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputThreeValue',
              isRead: 'true',
              interval: '1499',
              texttableentry: 'DeviceAnalogInputThreeValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarStagnationTemperatureOffset',
              isRead: 'true',
              interval: '1505',
              texttableentry: 'SolarStagnationTemperatureOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveOneTargetPositionPercent',
              isRead: 'true',
              interval: '1506',
              texttableentry: 'AccessoryValveOneTargetPositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveOneCurrentPositionPercent',
              isRead: 'true',
              interval: '1507',
              texttableentry: 'AccessoryValveOneCurrentPositionPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveOneMinMaxLimit',
              isRead: 'true',
              interval: '1508',
              texttableentry: 'AccessoryValveOneMinMaxLimit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpOneValue',
              isRead: 'true',
              interval: '1512',
              texttableentry: 'AccessoryPumpOneValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpTwoValue',
              isRead: 'true',
              interval: '1513',
              texttableentry: 'AccessoryPumpTwoValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpThreeValue',
              isRead: 'true',
              interval: '1514',
              texttableentry: 'AccessoryPumpThreeValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpOneStatistical',
              isRead: 'true',
              interval: '1518',
              texttableentry: 'AccessoryPumpOneStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpTwoStatistical',
              isRead: 'true',
              interval: '1519',
              texttableentry: 'AccessoryPumpTwoStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpThreeStatistical',
              isRead: 'true',
              interval: '1520',
              texttableentry: 'AccessoryPumpThreeStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryMixerOneOperationMode',
              isRead: 'true',
              interval: '1524',
              texttableentry: 'AccessoryMixerOneOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryNextDtc',
              isRead: 'true',
              interval: '1526',
              texttableentry: 'AccessoryNextErrorDtc',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_LastResetCause',
              isRead: 'true',
              interval: '1527',
              texttableentry: 'LastResetCause',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryStartupComplete',
              isRead: 'true',
              interval: '1528',
              texttableentry: 'AccessoryStartupComplete',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarRechargeSuppressionImpact',
              isRead: 'true',
              interval: '1529',
              texttableentry: 'SolarRechargeSuppressionImpact',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PlusBusAuthentication',
              isRead: 'true',
              interval: '1532',
              texttableentry: 'PlusBusAuthentication',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputTwoSelector',
              isRead: 'true',
              interval: '1534',
              texttableentry: 'DeviceAnalogInputTwoFunctionSelector',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitOdxVersion',
              isRead: 'true',
              interval: '1553',
              texttableentry: 'ElectronicControlUnitOdxVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatingSupport',
              isRead: 'true',
              interval: '1554',
              texttableentry: 'HeatingSupport',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarStaticTemperatureControlHysteresis',
              isRead: 'true',
              interval: '1598',
              texttableentry: 'SolarStaticTemperatureControlHysteresis',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarSecondaryDeltaTemperatureHysteresis',
              isRead: 'true',
              interval: '1599',
              texttableentry: 'SolarSecondaryDeltaTemperatureHysteresis',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SupportedFeatures',
              isRead: 'true',
              interval: '1660',
              texttableentry: 'SupportedFeatures',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarIntervalFunction',
              isRead: 'true',
              interval: '1719',
              texttableentry: 'SolarIntervalFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarPumpConfigurationSelection',
              isRead: 'true',
              interval: '1819',
              texttableentry: 'SolarPumpConfigurationSelection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarPumpCharacteristics',
              isRead: 'true',
              interval: '1820',
              texttableentry: 'SolarPumpCharacteristics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitSafeStateStatus',
              isRead: 'true',
              interval: '2969',
              texttableentry: 'ElectronicControlUnitSafeStateStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputOneValueStatistical',
              isRead: 'true',
              interval: '3113',
              texttableentry: 'DeviceDigitalOutputOneValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputTwoValueStatistical',
              isRead: 'true',
              interval: '3114',
              texttableentry: 'DeviceDigitalOutputTwoValueStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputThreeValueStatistical',
              isRead: 'true',
              interval: '3115',
              texttableentry: 'DeviceDigitalOutputThreeValueStatistical',
              isWrite: 'false',
            },
          ],
        },
      ],
    };
  }
}
